import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { ChatConnectionStore } from './chat-connection.store';
import { ChatStatus } from './chat-data.store';

export type ChatTab = 'chat' | 'channels' | 'pet-selection';

export const ChatUIStore = signalStore(
  withState({
    chatWidgetExpanded: false,
    activeTab: 'chat' as ChatTab,
    selectedChatId: null as string | null,
    pendingChatStatus: null as ChatStatus | null,
  }),

  withMethods((store) => {
    const conn = inject(ChatConnectionStore);
    return {
      openWidget: () => {
        patchState(store, { chatWidgetExpanded: true });
        conn.updateUnreadCount();
      },

      closeWidget: () => {
        patchState(store, { chatWidgetExpanded: false });
      },

      toggleWidget: () => {
        patchState(store, { chatWidgetExpanded: !store.chatWidgetExpanded() });
        conn.updateUnreadCount();
      },

      setActiveTab: (tab: ChatTab) => {
        patchState(store, { activeTab: tab });
      },

      setSelectedChat: (chatId: string | null) => {
        patchState(store, { selectedChatId: chatId });
      },

      setPendingChatStatus: (status: ChatStatus | null) => {
        patchState(store, { pendingChatStatus: status });
      },

      consumePendingChatStatus: (): ChatStatus | null => {
        const status = store.pendingChatStatus();
        patchState(store, { pendingChatStatus: null });
        return status;
      },

      resetUI: () => {
        patchState(store, {
          chatWidgetExpanded: false,
          activeTab: 'chat',
          selectedChatId: null,
          pendingChatStatus: null,
        });
      },
    };
  })
);
